export const APP_NAME = 'accessories-catalog';

export const ACCESSORIES_CATALOG_ROUTE_ROOT = '/accessoriesCatalog';
